import React, { useId, useState } from 'react';

/**
 * Tooltip — small label shown on hover/focus of its single child.
 * CSS-positioned relative to the wrapper. For accessibility the child is
 * described by the tooltip text via aria-describedby.
 *
 * Props:
 *   content: ReactNode
 *   placement: 'top' | 'bottom' | 'left' | 'right'  (default 'top')
 *   children: the trigger element (wrapped in an inline-flex span)
 */
const Tooltip = ({ content, placement = 'top', className = '', children }) => {
  const [open, setOpen] = useState(false);
  const id = useId();

  if (content == null) return children;

  return (
    <span
      className={`ps-tooltip ${className}`.trim()}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {React.isValidElement(children)
        ? React.cloneElement(children, { 'aria-describedby': open ? id : undefined })
        : children}
      {open && (
        <span role="tooltip" id={id} className={`ps-tooltip__bubble ps-tooltip__bubble--${placement}`}>
          {content}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
